<script>
  export let slug, tracking = false, type = "submit", callback = false, bStyle = "bg-obsidian hover:bg-deep_juniper-50 focus:bg-deep_juniper-50 focus:ring-deep_juniper-50"
</script>
<button type={type} data-tracking={tracking} on:click={callback} 
 class="{bStyle} focus:ring-offset-2 focus:outline-none focus:ring-2 group capitalize relative leading-3 text-lg pb-2 pt-3 px-4 border border-transparent font-display text-white transition duration-300 ease-out">
{slug}
</button>